var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon16/core/plus",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,8 L12,8 L12,9 L8,9 L8,13 L7,13 L7,9 L3,9 L3,8 L7,8 L7,4 L8,4 L8,8 Z",
    id: "Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.f30cda040acaffafb51b3720bcdb4ab1.svg";
export { ForwardRef as ReactComponent };